<template>
  <div class="outlets-container">
    <div class="left-side" :class="collapseBranches ? 'collapsed' : ''">
      <div class="wrap-left">
        <div class="outlet-top">
          <div class="__kfc_r_2 header">
            <span>
              {{ $t("branch") }}
            </span>
            <svg v-if="!collapseBranches" @click="toggleSvg" class="collapseSvg" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
              <path
                d="M3.50298 17.0072C3.38657 16.8911 3.29421 16.7532 3.2312 16.6013C3.16818 16.4494 3.13574 16.2866 3.13574 16.1222C3.13574 15.9578 3.16818 15.795 3.2312 15.6431C3.29421 15.4913 3.38657 15.3533 3.50298 15.2372L11.813 6.92721C11.9055 6.83451 12.0154 6.76096 12.1364 6.71078C12.2573 6.6606 12.387 6.63477 12.518 6.63477C12.6489 6.63477 12.7786 6.6606 12.8996 6.71078C13.0206 6.76096 13.1305 6.83451 13.223 6.92721L21.533 15.2372C22.023 15.7272 22.023 16.5172 21.533 17.0072C21.043 17.4972 20.253 17.4972 19.763 17.0072L12.513 9.76721L5.26298 17.0172C4.78298 17.4972 3.98298 17.4972 3.50298 17.0072Z"
                fill="black"
              />
            </svg>
            <svg v-else @click="toggleSvg" class="collapseSvg" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
              <path
                d="M3.59673 7.00353C3.48032 7.11965 3.38796 7.25759 3.32495 7.40945C3.26193 7.56131 3.22949 7.72412 3.22949 7.88853C3.22949 8.05295 3.26193 8.21575 3.32495 8.36762C3.38796 8.51948 3.48032 8.65742 3.59673 8.77353L11.9067 17.0835C11.9992 17.1762 12.1091 17.2498 12.2301 17.3C12.3511 17.3501 12.4808 17.376 12.6117 17.376C12.7427 17.376 12.8724 17.3501 12.9934 17.3C13.1143 17.2498 13.2242 17.1762 13.3167 17.0835L21.6267 8.77353C22.1167 8.28353 22.1167 7.49353 21.6267 7.00353C21.1367 6.51353 20.3467 6.51353 19.8567 7.00353L12.6067 14.2435L5.35673 6.99353C4.87673 6.51353 4.07673 6.51353 3.59673 7.00353Z"
                fill="black"
              />
            </svg>
          </div>
          <div class="address">
            <div class="address-inputs">
              <search-address :value="address" @getAddress="getAddress" classes="__kfc_orderType_select_dark" type="outlets" :key="address" />
              <current-location @getAddress="getCurrentAddress" :styles="{ background: '#F7F7F7' }" />
            </div>
            <div class="__kfc_r_10 result-desc"></div>
          </div>
        </div>
        <div class="outlet-lists">
          <div class="outlet-item" v-for="(item, index) in nearestOutlets" :key="index">
            <div class="outlet-item-wrap">
              <div class="item-desc">
                <div class="__kfc_r_5 item-header">
                  <span v-if="locale == 'mn'">{{ item.name_mn }}</span>
                  <span v-else>{{ item.name_en }}</span>
                </div>
                <div class="item-content">
                  <span class="__kfc_r_9"></span>
                  <span class="__kfc_r_8"> {{ item.start_time }} - {{ item.end_time }} </span>
                </div>
              </div>
              <div class="bottom-action" @click="goMenu(item.outletname)">
                <span class="__kfc_r_8">{{ $t("seeMenu") }}</span>
                <div class="action">
                  <img src="@/assets/icons/ph_arrow-square-right-fill.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-side">
      <GMapMap class="map" :center="center" :zoom="zoom" :options="options" :key="nearestOutlets">
        <GMapMarker
          v-if="address.full_address !== ''"
          :key="address"
          :position="{ lat: parseFloat(address.latitude), lng: parseFloat(address.longitude) }"
          :icon="markerCurrentPos"
          @click="
            () => {
              openedPlace = true;
            }
          "
          title=""
        >
          <GMapInfoWindow
            :closeclick="true"
            @closeclick="
              () => {
                openedPlace = false;
              }
            "
            :opened="openedPlace"
          >
            <div class="__marker_pin">
              <div class="__kfc_r_8 __marker_desc">
                <p>{{ address.full_address }}</p>
                <p>{{ address.bairnote }}</p>
              </div>
            </div>
          </GMapInfoWindow>
        </GMapMarker>
        <!-- <GMapMarker
          v-for="(location, index) in nearestOutlets"
          :key="index"
          :position="{ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) }"
          :icon="markerImg"
          :title="location.name_mn"
          @mouseover="markerMouseOver(location)"
          @mouseout="markerMouseOut(location)"
        > -->
        <GMapMarker
          v-for="(location, index) in nearestOutlets"
          :key="index"
          :position="{ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude) }"
          :icon="markerImg"
          :title="location.name_mn"
          @click="markerClick(location)"
        >
          <GMapInfoWindow :opened="location.outletname === openedOutlet" @closeclick="markerCloseClick(location.outletname)">
            <div class="__marker_pin">
              <div class="__marker_img">
                <img :src="cdn + location.img_url" alt="KFC mongolia" />
              </div>
              <div class="__kfc_r_8 __marker_desc">
                <span v-if="locale == 'mn'">{{ location.name_mn }}</span>
                <span v-else>{{ location.name_en }}</span>
                <!-- <p>{{ $t("open") }}:{{ location.start_time }} - {{ $t("close") }}:{{ location.end_time }}</p> -->
                <!-- <a :href="location.twords" target="_blank">{{location.twords}}</a> -->
                <!-- <div class="__phone">{{ $t("phone") }}:<span>7555-1010</span></div>
                <a :href="location.google_map_url" target="_blank" class="__btn_link">{{ $t("gotoGoogleMap") }}</a> -->
              </div>
            </div>
          </GMapInfoWindow>
        </GMapMarker>
      </GMapMap>
    </div>
  </div>
</template>

<script>
import configJson from "../../config";
import Req from "@/utils/Request";
import SearchAddress from "@/components/SearchAddress.vue";
import CurrentLocation from "@/components/CurrentLocation.vue";
import { computed, inject, onMounted, reactive, ref, watch } from "vue";
import markerImg from "@/assets/icons/marker.svg";
import markerCurrentPos from "@/assets/icons/ph_map-pin-fill.svg";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "OutletsView",
  components: { SearchAddress, CurrentLocation },
  setup() {
    const store = useStore();
    const router = useRouter();
    const notify = inject("notify");
    const orderType = computed(() => store.getters["address/getOrderType"]);
    const nearestOutlets = ref([]);
    const allOutlets = ref([]);
    const openedOutlet = ref(null);
    const openedPlace = ref(false);
    const collapseBranches = ref(false);
    const locale = computed(() => store.getters.locale);
    const address = ref(store.getters["address/getDeliveryAddress"]);
    const outletName = ref(store.getters["address/getActiveOutlet"]);
    const currPos = ref({ lat: 0, lng: 0, error: false });
    const zoom = ref(13);
    const cdn = configJson.CLOUDFRONT_IMAGE_PATH;
    const center = ref({ lat: 47.88830914483325, lng: 106.89362007284807 });
    const options = reactive({
      scrollwheel: true,
      streetViewControl: false,
      disableDefaultUI: false,
      mapTypeControl: false,
      minZoom: 10,
      maxZoom: 20,
      autobindAllEvents: false,
      gestureHandling: "greedy", // 'cooperative'//greedy
    });

    watch(nearestOutlets, () => {
      if (nearestOutlets.value.length === 0 || !nearestOutlets.value[0]) {
        // nearestOutlets.value = [];
        return;
      }
      center.value = {
        lat: parseFloat(nearestOutlets.value[0].latitude),
        lng: parseFloat(nearestOutlets.value[0].longitude),
      };
    });
    const getOutlets = async () => {
      const { data: result } = await Req({ url: "/manager/getOutlets", hideSuccess: true });
      if (result.success) {
        nearestOutlets.value = result.result;
        allOutlets.value = result.result;
      }
    };
    
    const getAddress = (addr) => {
      outletName.value = addr.outlet;
      address.value = addr.address;
      getNearestOutlets();
    };
    const markerClick = (outlet) => {
      openedOutlet.value = outlet.outletname;
      center.value = {
        lat: parseFloat(outlet.latitude),
        lng: parseFloat(outlet.longitude),
      };
    };
    const markerCloseClick = (outlet) => {
      if (openedOutlet.value === outlet) {
        openedOutlet.value = null;
      }
    };
    const markerMouseOver = (outlet) => {
      openedOutlet.value = outlet.outletname;
    };
    const markerMouseOut = (outlet) => {
      if (openedOutlet.value === outlet.outletname) {
        openedOutlet.value = null;
      }
    };
    const getCurrentAddress = (currAddress) => {      
      address.value = currAddress.address;
      currPos.value = {
        lat: currAddress.location.lat,
        lng: currAddress.location.lng,
      };
      center.value = {
        lat: currAddress.location.lat,
        lng: currAddress.location.lng,
      };
      zoom.value = 14;
      getNearestOutlets();
    };

    const getNearestOutlets = async () => {
      if (address.value.latitude === "" || address.value.longitude === "" || !address.value.latitude || !address.value.longitude) {
        notify.warning({
          message: locale.value == "mn" ? "Байршилын мэдээлэл хоосон байна" : "Not found geo",
          position: "top-left",
        });
        return;
      }
      
      if (orderType.value === 1) {
        isDeliveryOutlet();
      } else if (orderType.value === 2) {
        isPickupOutlets();
      }
    };
    const isDeliveryOutlet = () => {
        const currentOutletName = store.getters["address/getActiveOutlet"];
        const outlet = allOutlets.value.find((item) => item.outletname === currentOutletName);
        if (outlet) {
            nearestOutlets.value = [outlet];
        } else {
            nearestOutlets.value = [];
        }
    };
    const isPickupOutlets = async () => {
      const { data: result } = await Req({
        url: "/outletes/nearOutlets",
        body: {
          lat: address.value.latitude,
          long: address.value.longitude,
        },
        hideSuccess: true,
      });
      if (result.success) {
        nearestOutlets.value = result.result;
      }
    };
    const goMenu = (outletname) => {
      // Delivery outlet is always resolved from the address pod (getOutletNameByPodKfc);
      // writing it here can desync it from deliveryAddress and send the wrong
      // outlet at placeorder. Only pickup is an explicit branch choice.
      if (orderType.value === 2) {
        store.dispatch("address/updatePickupAddress", outletname);
      }
      router.push("/");
    };
    const toggleSvg = () => {
      collapseBranches.value = !collapseBranches.value;
    };

    onMounted(async () => {
      await getOutlets();
      if (address.value?.latitude !== "" && address.value?.longitude !== "" && orderType.value === 1) {
        isDeliveryOutlet();
      }
    });
    return {
      address,
      zoom,
      center,
      cdn,
      options,
      markerImg,
      openedPlace,
      openedOutlet,
      locale,
      nearestOutlets,
      markerCurrentPos,
      currPos,
      collapseBranches,
      goMenu,
      getAddress,
      getCurrentAddress,
      markerCloseClick,
      markerClick,
      markerMouseOver,
      markerMouseOut,
      toggleSvg,
    };
  },
};
</script>
<style scoped lang="scss">
.outlets-container {
  display: flex;
  position: relative;
  height: calc(100vh - 106px);
  
  @media (max-width: 900px) {
    display: block;
    height: calc(100vh - 54px);
  }

  .__marker_pin {
    background: $redMain;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    .__marker_img {
      height: 200px;
      width: 200px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .__marker_desc {
      text-align: center;

      span,
      p {
        color: $whiteMain;
      }
    }
  }

  .left-side {
    &.collapsed {
      height: 90%;
    }

    width: 30%;
    height: 100%;
    transition: ease-out 0.3s;

    @media (max-width: 900px) {
      width: 100%;
      position: absolute;
      height: 30%;
      bottom: 0;
      z-index: 1;
      background: #fff;
    }

    .wrap-left {
      padding: 40px;
      height: 100%;
      display: flex;
      flex-direction: column;

      .outlet-top {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .header {
          color: $redMain;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .collapseSvg {
            cursor: pointer;
            display: none;

            @media (max-width: 900px) {
              display: block;
            }
          }
        }

        .address {
          display: flex;
          flex-direction: column;
          gap: 12px;

          .address-inputs {
            display: flex;
            gap: 8px;
            height: 54px;
          }

          .result-desc {
            color: $dark80;
          }
        }
      }

      .outlet-lists {
        display: flex;
        flex-direction: column;
        gap: 8px;
        overflow-y: auto;
        height: 100%;

        .outlet-item {
          width: 100%;
          background: $dark3;
          border-radius: 4px;

          .outlet-item-wrap {
            padding: 16px;
            display: flex;
            flex-direction: column;
            gap: 4px;

            .item-desc {
              display: flex;
              flex-direction: column;
              gap: 12px;

              .item-content {
                display: flex;
                flex-direction: column;
                gap: 8px;
              }
            }

            .bottom-action {
              justify-content: flex-end;
              display: flex;
              gap: 8px;
              align-items: center;
              align-self: flex-end;
              cursor: pointer;

              span {
                color: $redMain;
              }

              .action {
                width: 25px;
                height: 25px;

                img {
                  width: 100%;
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }

  .right-side {
    width: 70%;

    @media (max-width: 900px) {
      width: 100%;
      height: 70%;
    }

    .map {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
>
